import { render, staticRenderFns } from "./importantform.vue?vue&type=template&id=37da829f&scoped=true"
import script from "./importantform.vue?vue&type=script&lang=js"
export * from "./importantform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37da829f",
  null
  
)

export default component.exports